import ModelFactory from 'business/models/ModelFactory';
import {
  PasteFolderTaskDTO,
  PasteOperationType,
  SaveImageRequestDTO,
  SaveImageTaskRequestDTO,
  SystemTaskResponseDTO,
  SystemTasksClient,
} from 'business/models/Models';
import BaseService from './BaseService';
import { FileSystemTaskResultDTO } from '../models/CustomModels';

export default class SystemTaskService extends BaseService {
  async copyPasteFolder(
    args: [number[], number, PasteOperationType],
    taskId: number,
  ): Promise<SystemTaskResponseDTO> {
    const client: SystemTasksClient = ModelFactory(SystemTasksClient, false, false);
    const pasteFolderTask = new PasteFolderTaskDTO();
    pasteFolderTask.treeNodeIdsToPaste = args[0];
    pasteFolderTask.targetId = args[1];
    pasteFolderTask.id = taskId;
    pasteFolderTask.operationType = args[2];
    return client.pasteFolder(pasteFolderTask);
  }

  async saveImage(args: any[], taskId: number): Promise<SystemTaskResponseDTO> {
    const client: SystemTasksClient = ModelFactory(SystemTasksClient, false, false);
    const saveImageDto = new SaveImageRequestDTO();
    saveImageDto.init(args[0].saveImageRequestDTO as SaveImageRequestDTO);
    const dto = new SaveImageTaskRequestDTO();
    dto.saveImageRequestDTO = saveImageDto;
    dto.id = taskId;
    const fileResult = new FileSystemTaskResultDTO();
    fileResult.responseFile = await client.saveImage(dto);
    const result = new SystemTaskResponseDTO();
    result.result = fileResult;
    result.success = true;
    return result;
  }
}
